import React from 'react';
import TitleInput from './TitleInput';

const EditForm: React.FC<{
  postTitle: string;
  setPostTitle: (val: string) => void;
}> = ({ postTitle, setPostTitle }) => {
  return (
    <div className="flex-1">
      <h2 className="mb-4 text-xl font-bold">글 작성하기</h2>
      <div className="flex space-x-4 w-full">
        <TitleInput title={postTitle} setTitle={setPostTitle} />
      </div>
    </div>
  );
};

export default EditForm;
